import { CommonContext } from '@repo-level/core-front';
import { NotAllowedCountry } from 'components/internal/NotAllowedCountry';
import { useFranceLocale } from 'hooks/franceLocale';
import type { FC } from 'react';
import { useContext } from 'react';

export const Restricted: FC = ({ children }) => {
  const { isRestricted } = useFranceLocale();
  const { currentIp } = useContext(CommonContext);

  if (currentIp && isRestricted) {
    return <NotAllowedCountry countryCode={currentIp?.countryCode} />;
  }

  return <>{children}</>;
};
